import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootRouter from './RootRouter';
import { applyTheme, getStoredTheme, ThemeProvider } from './context/theme.context';
/* Load last so tablet/laptop + brand button overrides win the CSS cascade */
import './app/ProviderResponsive.css';

applyTheme(getStoredTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <RootRouter />
  </ThemeProvider>
);
